export const version = '3.2.0';
export const buildDate = 'Mon, 26 Oct 2026 12:12:36 GMT';
export const commitHash = 'ac8c738a';